import React from "react";

export default function ConfirmationModal({
  open,
  title,
  description,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  onCancel,
  onConfirm,
}) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl p-8 max-w-lg w-full shadow-xl">
        <div className="mb-6">
          <h2 className="text-2xl font-bold mb-2">{title}</h2>
          <p className="text-lg text-gray-800">{description}</p>
        </div>
        <div className="flex justify-between gap-4 mt-8">
          <button
            className="px-8 py-3 rounded-full border border-gray-400 text-gray-800 font-medium bg-white transition text-lg"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
          <button
            className="px-8 py-3 rounded-full font-medium bg-[#E3000B] text-white transition text-lg"
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
